import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz'
import { format } from 'date-fns';
import { apiTimezoneIdsToLetterCodes } from './config/timeZoneCodes';

const getProcessedGameDate = (opts = {}) => {
    const et = 'America/New_York';
    const { datetime: { dateTime = '' } = {}, tz} = opts;
    if (!dateTime) {
        return '';
    }
    const UTCDate = zonedTimeToUtc(dateTime, tz); // convert to UTC first based on the given timezone
    const time = format(utcToZonedTime(UTCDate, 'America/New_York'), "h:mm aaaaa'm'"); // convert to ET timezone
    return `${time} ${apiTimezoneIdsToLetterCodes[et]}`;
};

export default getProcessedGameDate;